import Header from '../../Shared-Component/Header/Header'
import CampusTitle from '../../CampusLife/CampusSharedComponent/CampusTitles/CampusTitle/CampusTitle'
import MOUone from "../../assets/Images/MOUone.png"
import { Button } from "primereact/button";
import "../MOU/MOU.scss"
import MOUtwo from "../../assets/Images/MOUtwo.jpg"
import MOUthree from "../../assets/Images/MOUthree.jpg"
import MOUfour from "../../assets/Images/MOUfour.jpeg"
import MOUfive from "../../assets/Images/MOUfive.jpeg"
import MOUsix from "../../assets/Images/MOUsix.jpeg"
import MOUseven from "../../assets/Images/MOUseven.jpeg"
import MOUeight from "../../assets/Images/MOUeight.jpeg"
import MOUnine from "../../assets/Images/MOUnine.jpg"
import { useState } from 'react';

const MOU = () => {

     const [mouTo, setMouTo] = useState("");

    const data = {
        name: "MOU",
    }

    const content = [
        {
            img: MOUone,
            companyName : "Bhumi - The World’s Leading Volunteering Non-Governmental Organization,",
            companyAddress: "Company Address",
            houseNumber: "3/2",
            street: "Karpaga Vinayagar Koil Street",
            road: "",
            place: "Alandur",
            city: "Chennai",
            state: "TamilNadu",
            postalcode: "600016,",
            country: "India",
            mouFrom: "MOU from",
            start: "16.5.2024",
            benefits: "Benefits",
            benefitsContent: "Engaging students in volunteering activities.",
            buttons: ["All Department"]

        },
        {
            img: MOUtwo,
            companyAddress: "Company Address",
            companyName : "Feather S/ws,",
            houseNumber: "Abivil Compound",
            street: "Court road",
            road: "",
            place: "Kandaswamy Market",
            city: "Nagercoil",
            state: "TamilNadu",
            postalcode: "629001,",
            country: "India",
            mouFrom: "MOU from",
            start: "16.5.2024",
            benefits: "Benefits",
            benefitsContent: "Provide a wide range of orientation courses and workshop for free of cost.",
            buttons: ["B.Sc. Computer Science", "B.Sc. Information Technology", "B.C.A."]

        },
        {
            img: MOUthree,
            companyAddress: "Company Address",
            companyName : "ELTAI,",
            houseNumber: "D-54",
            street: "Anandham Apartments",
            road: "SIDCO Nager Main Road",
            place: "Villivakkam",
            city: "Chennai",
            state: "",
            postalcode: "600049,",
            country: "",
            mouFrom: "MOU from",
            start: "12.12.2023",
            benefits: "Benefits",
            benefitsContent: "Cultivate the habit of reading.",
            buttons: ["All Department"]

        },
        {
            img: MOUfour,
            companyAddress: "Company Address",
            companyName : "Synergy,",
            houseNumber: "2nd Floor",
            street: "Dharmaraj Complex",
            road: "",
            place: "Court Road",
            city: "Nagercoil",
            state: "Kanyakumari District",
            postalcode: "629001,",
            country: "TamilNadu",
            mouFrom: "MOU from",
            start: "02.04.24",
            benefits: "Benefits",
            benefitsContent: "Provide a wide range of orientation courses and workshop for free of cost.",
            buttons: ["B.Com.", "M.Com.", "B.B.A."]

        },
        {
            img: MOUfive,
            companyAddress: "Company Address",
            companyName : "Avigen Biotech Pvt. Ltd.,",
            houseNumber: "Ist floor",
            street: "Ist Main Road",
            road: "New colony",
            place: "Chromepet",
            city: "Chennai",
            state: "",
            postalcode: "44",
            country: "",
            mouFrom: "MOU from",
            start: "30.1.2024",
            benefits: "Benefits",
            benefitsContent: "Provides Internship, hands on training, workshop and projects in different areas of life science courses.",
            buttons: ["B.Sc. Biotechnology", "B.Sc. Microbiology", "B.Sc. Chemistry", "M.Sc. Biotechnology"]

        },
        {
            img: MOUsix,
            companyAddress: "Company Address",
            companyName : "AK Infopark Pvt. Ltd.,",
            houseNumber: "6-101",
            street: "Trivandrum Main Road",
            road: "",
            place: "Parvathipuram",
            city: "Nagercoil",
            state: "TamilNadu",
            postalcode: "629003,",
            country: "India",
            mouFrom: "MOU from",
            start: "14.12.2023",
            benefits: "Benefits",
            benefitsContent: "Provides software development, skill development, Business development and Financial accounting training in the field of Information Technology, Multimedia, Business Management and Financial Accounting related fields.",
            buttons: ["B.Sc. Computer Science", "B.C.A.", "B.Sc. Information Technology"]

        },

        {
            img: MOUseven,
            companyAddress: "Company Address",
            companyName : "Biomeitez Research & Development Pvt. Ltd.,",
            houseNumber: "2-165/7",
            street: "North Saral",
            road: "",
            place: "Saral Post",
            city: "Kanayakumari District",
            state: "TamilNadu",
            postalcode: "",
            country: "India",
            mouFrom: "MOU from",
            start: "03.01.2024",
            benefits: "Benefits",
            benefitsContent: "Provides research and development services to life science students.",
            buttons: ["B.Sc. Biotechnology", "B.Sc. Microbiology", "B.Sc. Chemistry", "M.Sc. Biotechnology"]

        },

        {
            img: MOUeight,
            companyAddress: "Company Address",
            companyName : "Clovion Tech Solutions Pvt. Ltd.,",
            houseNumber: "1st Floor",
            street: "AJR Complex",
            road: "",
            place: "Azhagiyamandapam Jn",
            city: "Kanayakumari District",
            state: "TamilNadu",
            postalcode: "629167,",
            country: "India",
            mouFrom: "MOU from",
            start: "22.1.2024",
            benefits: "Benefits",
            benefitsContent: "Offers technical skill development and internship opportunities in diverse technology.",
            buttons: ["B.Sc. Computer Science", "B.C.A.", "B.Sc. Information Technology"]

        },
        {
            img: MOUnine,
            companyAddress: "Company Address",
            companyName : "Finura Agro Tech LLP,",
            houseNumber: "11-8",
            street: "Finura Garden",
            road: "",
            place: "Loyola College Road",
            city: "Thovalai",
            state: "Kanyakumari",
            postalcode: "629302,",
            country: "TamilNadu",
            mouFrom: "MOU from",
            start: "20.1.2024",
            benefits: "Benefits",
            benefitsContent: "Provides agricultural and animal husbandry service activities to Life Science Students.",
            buttons: ["B.Sc. Biotechnology", "B.Sc. Microbiology", "B.Sc. Chemistry", "M.Sc. Biotechnology"]

        },
    ]
    return (
        <div>
            <Header />
            <div>
                <div className='campus-container'>
                    <CampusTitle title={data.name} />
                    <div className='MOU-container'>
                        {
                            content.map((item, index) => (
                                <div className='MOU-subcontainer'>
                                    <div className='MOU-right-container'>
                                        <div className='MOU-right-subcontainer'>
                                        <div className='right-img-container' ><img src={item.img}>
                                        </img>
                                        </div>
                                        <div className='right-button-container'>
                                            <div className='date-container'>
                                                <p>{item.mouFrom}<span>:</span>{item.start}</p>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className='MOU-left-container'>
                                        <div className='left-address-container'>
                                            <h2>{item.companyAddress}</h2>
                                            <h3>{item.companyName}</h3>
                                            <div className='address-container'>
                                                {
                                                    item.houseNumber && item.street && <p>{item.houseNumber}<span>,</span>{item.street}<span>,</span></p>
                                                }
                                                {
                                                    item.road && <p>{item.road}<span>,</span></p>
                                                }
                                                {
                                                    item.place && <p>{item.place}<span>,</span></p>
                                                }
                                                {
                                                    item.city && item.postalcode && <p>{item.city}<span style={{ paddingLeft: "5px", paddingRight: "5px" }}>-</span>{item.postalcode}</p>
                                                }
                                                {
                                                    item.state && item.country && <p>{item.state}<span>,</span>{item.country}</p>
                                                }

                                            </div>
                                        </div>
                                        <div className='benefits-container'>
                                            <h2>{item.benefits}</h2>
                                            <p>{item.benefitsContent}</p>
                                        </div>
                                        <div className='left-buttons-container'>
                                            {
                                                item.buttons.map((buttonitem, buttonindex) => (

                                                    <Button label={buttonitem} />
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default MOU